import { FunctionComponent } from 'preact';

import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';
import { AdLink } from '../AdLink/AdLink';
import { ButtonProps } from '../Button/Button';

export const PauseAdLink: FunctionComponent<{
  size?: ButtonProps['size'];
}> = ({ size }) => {
  const { t } = useTranslation(ns);

  return (
    <AdLink
      label={t('advertisement')}
      className="vgp-ad-link-pause"
      size={size}
    />
  );
};
